// src/admin/components/FilterChipGroup.jsx
import React from 'react';
import { COLORS, RADII, FONT_SANS } from '../../constants/theme.js';

export default function FilterChipGroup({ options, value, onChange }) {
  function toggle(v) {
    const next = value.includes(v) ? value.filter(x => x !== v) : [...value, v];
    onChange(next);
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      {options.map(opt => {
        const active = value.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => toggle(opt.value)}
            style={{
              padding: '5px 10px', borderRadius: RADII.pill,
              border: `1px solid ${active ? COLORS.accent : COLORS.borderStrong}`,
              background: active ? COLORS.accentSoft : COLORS.surface,
              color: active ? COLORS.accent : COLORS.ink,
              fontSize: '12px', fontWeight: active ? 600 : 400,
              cursor: 'pointer',
              fontFamily: FONT_SANS,
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
